import React from 'react';
import Ongoing from '../../images/ongoing-img.png'
import Arrow from "../../images/long-arrow-right.svg"
import { useMediaQuery } from "react-responsive"

const OnGoingCommunity = () => {
  let isMobile = useMediaQuery({ query: "(max-device-width: 576px)" })
    return (
      <section id="ongoing-community">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="title-txt">Key Strategy</div>
              <h1>Ongoing Community</h1>
              {isMobile ? (
                <></>
              ) : (
                <button className="find-help-btn btn">
                  Learn more
                  <span className="pl-2">
                    <img src={Arrow} alt="" style={{ margin: "0" }} />
                  </span>
                </button>
              )}
            </div>
            <div class="col-md-6 mt-5">
              <p>
                Rehabilitation is a lifelong process. To achieve sobriety is a
                step-by-step procedure that requires immense determination and
                persistence. Hence, having a support network and a community
                encouraging a recovering patient is a must!.
              </p>
            </div>
          </div>
          {isMobile ? (
            <button className="find-help-btn btn">
              Learn more
              <span className="pl-2">
                <img src={Arrow} alt="" style={{ margin: "0" }} />
              </span>
            </button>
          ) : (
            <></>
          )}
          <div class="row resourse-desc-wrapper"></div>
          <div class="col-md-6 img-wrapper-xs ">
            <img src={Ongoing} alt="" class="img-one img-fluid" />
          </div>
          <div class="row resourse-desc-wrapper"></div>

          <div class="row resourse-desc-wrapper">
            <div class="col-md-6 my-auto text-wrapper">
              <p>
                Rehab Find has set-up an ongoing community that aims to empower
                people as they go through the rehabilitation journey. A support
                network such as this is a pivotal factor for rehabilitation. If
                you are looking for fellow people who share your commitment to
                rehabilitation and transformation, we’d love to have you join
                our community!
              </p>
            </div>
            <div class="col-md-6 img-wrapper text-center">
              <img src={Ongoing} alt="" class="img-one img-fluid" />
            </div>
          </div>
        </div>
      </section>
    )
}
 
export default OnGoingCommunity;